export const PdfFiles = () => {
    const files = ['Публічна оферта', 'Положення про обробку і захист персональних даних']; // Замените на названия ваших файлов

  return (
    <div>
      {files.map((file, index) => (
        <p key={index}>
          <a href={`/${file}.pdf`} target="_blank" rel="noopener noreferrer">
            {file}
          </a>
        </p>
      ))}
    </div>
  );
}